import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions'
import AssignPageContent from '../../../../components/PageContent/Assignment/AssignPageContent/AssignPageContent'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import Alert from '../../../../components/Alert/Alert'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

const frequencyCountMapping = {
  FQT01: 1,
  FQT02: 2,
  FQT03: 4,
  FQT04: 12,
  FQT05: 365,
  FQT06: 48
}

class AssignPage extends Component {
  state = {
    confirmationModalOpen: false,
    assignmentData: [],
    drafted: false,
    assignmentItems: null,
    action: 'add',
    responsibleTimer: null
  }

  componentDidMount() {
    let assignmentId = this.props.match.params.id
    let action = 'add'
    const { assignmentTargetIds, appraisalType, assignmentItemIds, assignmentItems } = this.props

    if (+assignmentId) {
      if (!this.props.assignmentInfo?.result_id) {
        this.props.fetchAssignmentById(assignmentId)
      }
      action = 'edit'
    } else {
      if (assignmentTargetIds.length < 1 || assignmentItemIds.length < 1) {
        if (appraisalType) {
          let redirectPath = null
          if (appraisalType.appraisal_type_code === 'APT02') {
            redirectPath = '/assignment/individual'
          } else {
            redirectPath = '/assignment/corporate'
          }

          return this.props.history.replace(redirectPath)
        } else {
          return this.props.history.replace('/assignment/individual')
        }
      }
    }

    this.props.fetchFrequencyTypeOptions()
    this.props.fetchScoreOptions()

    this.setState({
      assignmentData: [...assignmentItems],
      action: action
    })
  }

  static getDerivedStateFromProps(props, state) {
    let updatedState = {}
    if (props.assignmentItems !== state.assignmentItems) {
      const updatedAssignmentItems = props.assignmentItems.reduce(
        (selectedStructures, structure) => {
          const structType = structure.structure_type?.value_list_code
          let selectedStructureItems = structure.result_item

          // Find draft structure (Case edit)
          const draftStructure = state.assignmentData.find(struct => {
            return +struct.structure_id === +structure.structure_id
          })

          // Apply structure ID and Name to each items (to display as table)
          if (structType === 'STT01') {
            selectedStructureItems = (selectedStructureItems || [])?.map(item => {
              const responsibleList = item.responsible_list || []
              let updatedItem = { ...item, responsible_list: responsibleList }

              // Find draft item and add all attributes to item
              if (draftStructure) {
                const draftItem = draftStructure.result_item.find(
                  draftItem => +draftItem.item_id === +item.item_id
                )

                // In case we have drafted data, we will keep all thier changes, except responsible_list.
                if (draftItem) {
                  return {
                    ...updatedItem,
                    ...draftItem,
                    responsible_id: draftItem.responsible_id,
                    responsible_list: responsibleList
                  }
                }
              }

              // If no draft data just apply structure ID and Name to each item
              return updatedItem
            })
          }

          // Check if any items of current structure have been selected,
          // If selected, add structure to assignment data, else skip it
          if (selectedStructureItems.length > 0) {
            // If draft structure exists, use draft structure data instead.
            if (draftStructure) {
              return [
                ...selectedStructures,
                { ...structure, ...draftStructure, result_item: selectedStructureItems }
              ]
            }
            // Else, just add to assignment data
            return [...selectedStructures, { ...structure, result_item: selectedStructureItems }]
          }
          return [...selectedStructures, { ...structure, result_item: selectedStructureItems }]
        },
        []
      )
      updatedState = {
        ...updatedState,
        assignmentData: updatedAssignmentItems,
        assignmentItems: props.assignmentItems
      }
    }
    if (props.assignmentInfo !== state.assignmentInfo) {
      const assignmentEditTarget = props.assignmentInfo
      const appraisalType = props.appraisalType
      let assignmentTargetIds = props.assignmentTargetIds

      if (assignmentEditTarget && !assignmentTargetIds.length) {
        if (appraisalType?.appraisal_type_code === 'APT02') {
          assignmentTargetIds = [assignmentEditTarget.emp_detail_id]
        } else {
          assignmentTargetIds = [assignmentEditTarget.org_id]
        }
      }

      props.setAssignTarget(assignmentTargetIds, appraisalType)
      updatedState = {
        ...updatedState,
        assignmentInfo: props.assignmentInfo
      }
    }
    return updatedState
  }

  componentWillUnmount = () => {
    let drafted = this.state.drafted
    if (!drafted) {
      this.clearData()
    }
  }

  clearData = () => {
    this.setState({
      form: { stage_id: null, remark: '' },
      assignmentData: [],
      drafted: false,
      action: 'add'
    })
    this.props.clearSelectedAssignmentItems()
  }

  addButtonClickedHandler = () => {
    this.setState(
      {
        drafted: true
      },
      () => {
        let itemIds = []
        const draftData = this.state.assignmentData.map(structure => {
          const structureCode = structure.structure_type.value_list_code
          let items = []
          if (structureCode !== 'STT05') {
            items = structure.result_item.map(item => {
              itemIds = [...itemIds, +item.item_id]
              return { ...item, tableData: null }
            })
          } else {
            items = Object.entries(structure.result_item).reduce((groups, group) => {
              const [groupCode, groupAttrs] = group
              const draftedGroupItems = groupAttrs.items.map(item => {
                itemIds = [...itemIds, +item.item_id]
                return {
                  ...item,
                  tableData: null
                }
              })
              return { ...groups, [groupCode]: { ...groupAttrs, result_item: draftedGroupItems } }
            }, {})
          }

          return {
            ...structure,
            result_item: items
          }
        })
        this.props.saveAssignmentDraft(draftData, itemIds)

        this.props.history.push({ pathname: '/assignment/items', state: { fromAssignPage: true } })
      }
    )
  }

  assignmentInputChangedHandler = (updatedStructure, structureId, itemId, value) => {
    if (structureId && itemId) {
      return this.assignmentAdoptedHandler(structureId, itemId, value)
    }
    const structureTypeCode = updatedStructure.structure_type?.value_list_code

    const updatedData = this.state.assignmentData.map(structure => {
      if (
        +updatedStructure.result_structure_id === +structure.result_structure_id ||
        +updatedStructure.structure_id === +structure.structure_id
      ) {
        let currentIds = []
        let updatedResultItems = []
        if (structureTypeCode !== 'STT05') {
          currentIds = updatedStructure.result_item.map(item => +item.item_id)
          updatedResultItems = structure.result_item.reduce((updated, item) => {
            if (currentIds.includes(+item.item_id)) {
              const targetItem = updatedStructure.result_item.find(
                i => +i.item_id === +item.item_id
              )
              if (targetItem) {
                return [...updated, { ...item, ...targetItem }]
              }
              return [...updated, item]
            }
            return updated
          }, [])
        } else {
          updatedResultItems = Object.entries(structure.result_item).reduce((updated, group) => {
            const [groupCode, groupAttrs] = group
            const updatedGroup = updatedStructure.result_item[groupCode]

            return {
              ...updated,
              [groupCode]: { ...groupAttrs, ...updatedGroup }
            }
          }, {})
        }
        return {
          ...structure,
          ...updatedStructure,
          result_item: updatedResultItems
        }
      }
      return structure
    })

    this.setState({
      assignmentData: updatedData
    })
  }

  responsibleSearchChangedHandler = (searchValue, structureId, itemData) => {
    const existingTimer = this.state.responsibleTimer
    if (existingTimer) {
      clearTimeout(existingTimer)
    }

    const timer = setTimeout(() => {
      const { assignmentInfo } = this.props
      const options = {
        company_id: assignmentInfo?.company_id,
        appraisal_type_id: assignmentInfo?.appraisal_type_id,
        filter: searchValue
      }
      this.props.fetchResponsibleDropdownOptions(options, structureId, itemData)

      this.setState({ responsibleTimer: null })
    }, 500)
    this.setState({ responsibleTimer: timer })
  }

  assignmentAdoptedHandler = (structureId, itemId, isAdopted) => {
    const copiedAssignmentData = [...this.state.assignmentData]
    const updatedData = copiedAssignmentData.map(structure => {
      if (+structure.structure_id === +structureId) {
        const updatedResultItem = structure.result_item.map(item => {
          if (+item.item_id === +itemId) {
            item = { ...item, is_adopt: isAdopted }
            if (isAdopted) {
              if (item.adopt_allowed && item.adopt_item) {
                return {
                  ...item,
                  ...item.adopt_item,
                  is_deploy: item.is_deploy,
                  is_adopt: isAdopted,
                  result_item_id: item.result_item_id
                }
              }
              return item
            } else {
              const oldStructure = this.props.assignmentItems.find(
                struct => +struct.structure_id === +structureId
              )
              if (!oldStructure) {
                return item
              }

              const oldItem = oldStructure.result_item?.find(item => +item.item_id === +itemId)
              if (!oldItem) {
                return item
              }
              return { ...oldItem, is_adopt: isAdopted }
            }
          }
          return item
        })
        return { ...structure, result_item: updatedResultItem }
      }
      return structure
    })

    this.setState({
      assignmentData: updatedData
    })
  }

  assignmentSubmittedHandler = structureData => {
    if (this.state.action === 'edit') {
      let assignmentData = {
        ...this.props.assignmentInfo,
        result_structure: [structureData]
      }

      this.props.updateAssignment(assignmentData)
    } else {
      let assignmentData = {
        ...this.props.assignmentInfo,
        assign_target: this.props.assignmentTargetIds,
        result_structure: [structureData]
      }

      this.props.saveAssignment(assignmentData)
    }
  }

  openConfirmationModalHandler = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  assignmentCancelledHandler = () => {
    this.clearData()
    const appraisalType = this.props.appraisalType
    if (appraisalType) {
      let redirectPath = null
      if (appraisalType.appraisal_type_code === 'APT02') {
        redirectPath = '/assignment/individual'
      } else {
        redirectPath = '/assignment/corporate'
      }

      this.props.history.replace(redirectPath)
    } else {
      this.props.history.replace('/assignment/individual')
    }
    this.closeConfirmationModal()
  }

  applyKpiResultToAllRows = rowData => {
    this.setState(prevState => {
      const updatedData = prevState.assignmentData.map(item => {
        if (
          +item.structure_id === +rowData.structure_id ||
          +item.result_structure_id === +rowData.result_structure_id
        ) {
          if (!rowData.result_kpi) {
            return item
          }
          const resultBase = rowData.result_kpi[0]
          const frequencyType = this.props.frequencyOptions.find(
            item => item.value_list_id === rowData.frequency_type_id
          )

          const frequencyCount = frequencyCountMapping[frequencyType.value_list_code]
          if (frequencyCount && resultBase) {
            let updatedResults = []
            for (let index = 1; index <= frequencyCount; index++) {
              const rowExists = rowData.result_kpi.find(item => +item.frequency_no === +index)
              updatedResults.push({
                ...resultBase,
                frequency_no: index,
                result_kpi_id: rowExists?.result_kpi_id || null,
                result_item_id: rowExists?.result_item_id || null
              })
            }

            return {
              ...item,
              result_item: item.result_item.map(i => {
                if (+i.item_id === +rowData.item_id) {
                  return { ...i, result_kpi: updatedResults }
                }
                return i
              })
            }
          }
          return item
        }
        return item
      })

      return { assignmentData: updatedData }
    })
  }

  render() {
    return (
      <Aux>
        <Alert />
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          header={this.props.translate('cancelAssignment')}
          promptText={this.props.translate('confirmLeavePage')}
          confirmed={this.assignmentCancelledHandler}
          cancelled={this.closeConfirmationModal}
        />
        <AssignPageContent
          // Assignment Information Props
          assignmentInfo={this.state.action === 'add' ? null : this.props.assignmentInfo}
          assignmentTargetIds={this.props.assignmentTargetIds}
          appraisalType={this.props.appraisalType}
          // Action Props
          fireAlert={this.props.fireAlert}
          submitButtonDisabled={
            !this.props.pagePermission?.is_edit ||
            this.props.loadingQueue.includes('saveAssignment')
          }
          assignSuccessList={this.props.assignSuccessList}
          addButtonClicked={this.addButtonClickedHandler}
          submitButtonClicked={this.assignmentSubmittedHandler}
          cancelButtonClicked={this.openConfirmationModalHandler}
          applyButtonClicked={this.applyKpiResultToAllRows}
          // Assignment table props
          assignmentData={this.state.assignmentData}
          inputChanged={this.assignmentInputChangedHandler}
          adoptChanged={this.assignmentAdoptedHandler}
          responsibleSearchChanged={this.responsibleSearchChangedHandler}
          // Dropdown option props
          frequencyOptions={this.props.frequencyOptions}
          responsibleOptions={this.props.responsibleOptions}
          competencyScoreOptions={this.props.competencyScoreOptions}
          stageOptions={this.props.stageOptions}
          pagePermission={this.props.pagePermission}
          loadingQueue={this.props.loadingQueue}
        />
      </Aux>
    )
  }
}

const mapStateToProps = state => ({
  assignmentTargetIds: state.assignmentFlow.assignmentTargetIds,
  appraisalType: state.assignmentFlow.appraisalType,
  assignmentItemIds: state.assignmentFlow.assignmentItemIds,
  assignmentItems: state.assignmentFlow.assignmentItems,
  frequencyOptions: state.assignmentFlow.frequencies,
  responsibleOptions: state.assignmentFlow.responsibles,
  assignmentInfo: state.assignmentFlow.assignmentInfo,
  // assignmentData: state.assignmentFlow.assignmentData,
  loadingQueue: state.assignmentFlow.loadingQueue,
  filter: state.assignmentFlow.filter,
  assignSuccessList: state.assignmentFlow.assignSuccessList,
  competencyScoreOptions: state.assignmentFlow.competencyScores
})

const mapDispatchToProps = dispatch => ({
  fireAlert: message => {
    dispatch(
      actions.enqueueSnackbar({
        message,
        options: {
          variant: 'error'
        }
      })
    )
  },
  fetchResponsibleDropdownOptions: (options, structureId, itemId) => {
    dispatch(actions.fetchResponsibleOptionsForAppraisal(options, structureId, itemId))
  },
  fetchFrequencyTypeOptions: filterOptions => {
    dispatch(actions.fetchFrequencyTypeOptions(filterOptions))
  },
  fetchScoreOptions: filterOptions => dispatch(actions.fetchCompetencyScoreOptions(filterOptions)),
  fetchAssignmentById: recordId => {
    dispatch(actions.fetchAssignmentDataById(recordId))
  },
  clearSelectedAssignmentItems: () => dispatch(actions.clearAssignmentItems()),
  setAssignTarget: (targetIds, appraisalType) => {
    dispatch(actions.setAssignTarget(targetIds, appraisalType))
  },
  saveAssignmentDraft: (draftData, itemIds) =>
    dispatch(actions.saveAssignmentDraft(draftData, itemIds)),
  saveAssignment: data => dispatch(actions.saveAssignment(data)),
  updateAssignment: data => dispatch(actions.updateAssignment(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(AssignPage))
